import { photoUrlBase } from 'constants/common';

export const howToOrderItem = {
	title: 'Оформить шторы на заказ в магазине',
	contentItems: [
		'Перед приездом в магазин сделайте замеры окна.',
		'В магазине вместе с дизайнером выберите тип и цвет ткани и получите готовый дизайн-проект.',
	],
	buttonText: 'Выбрать ближайший магазин',
	imgAlt: 'Оформить шторы в магазине',
	imgUrls: {
		lDesk: `${photoUrlBase}/Ha2JTz2gvki_NkW9xqpQOg/services-platform-instore-landing-how-to-order-in-store-l-desk.png`,
		tab: `${photoUrlBase}/Vlx5Q7K8vkCaQR0pXmuxtA/services-platform-instore-landing-how-to-order-in-store-tab.png`,
		mob: `${photoUrlBase}/bubNh6Fl7Uab6toWFg7eUA/services-platform-instore-landing-how-to-order-in-store-mob.jpg`,
	},
	dataQa: 'how-to-order-in-store',
};
